export default {
  type: "object",
  properties: {
    short: {
      type: "string",
      description: "short localize description",
      example: "změř se"
    },
    label: {
      type: "string",
      description: "long localize description",
      example: "změř se důkladněji"
    }
  }
};
